import { VoiceProse } from "@/components/ui/voice-prose";
import type { ReactNode } from "react";
import { Kicker } from "@/components/ui/kicker";

/**
 * SituationNarrative — a scenario's situation, persona-neutral domain
 * narrative written in the voice of the situation. The one serif moment on
 * scenario pages; upright (not a quotation), 16px, relaxed leading.
 */
export function SituationNarrative({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <VoiceProse className={className}>{children}</VoiceProse>;
}

/** SituationTension — the situation's tension phrase, labelled. Interface text. */
export function SituationTension({ children }: { children: ReactNode }) {
  return (
    <div className="space-y-1">
      <Kicker>The tension</Kicker>
      <p className="text-base text-foreground">{children}</p>
    </div>
  );
}
